/* global $ */

import 'slick-carousel';

const $reviews = $('.js-card-reviews');

const cardReviews = {
  initialize() {
    if ($reviews.length) {
      this.createListeners();
    }
  },

  createListeners() {
    $reviews.slick({
      fade: true,
      arrows: false,
      cssEase: 'linear',
      infinite: true,
      autoplay: true,
      centerMode: true,
      mobileFirst: true,
      autoplaySpeed: 3000,
      centerPadding: '0',
      adaptiveHeight: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [],
    });
  },
};

export default cardReviews;
